// extracted by mini-css-extract-plugin
module.exports = {"heading":"sect_heading__1xEbE","element":"sect_element__3DxQx","text":"sect_text__hnGu3","body":"sect_body__28zfn"};